import { FormProvider, useForm } from 'react-hook-form';
import { Button, LoadingOverlay } from '@inexture/core';
import { PasswordInput, TextInput } from '@/form/elements/components';
import {
  loginInitials,
  LoginSchema,
  LoginSchemaT
} from '@/form/auth/login.schema.ts';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'sonner';
import { useLoginMutation } from '@services/auth.service.ts';

const LoginForm = () => {
  const [login, { isLoading }] = useLoginMutation();
  const methods = useForm<LoginSchemaT>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: zodResolver(LoginSchema),
    defaultValues: loginInitials
  });

  const handleFormSubmit = async (values: LoginSchemaT) => {
    const updatedValues = {
      ...values,
      username: values?.username?.toLowerCase()
    };
    await login(updatedValues)
      .unwrap()
      .then(() => {
        toast.success('Login successful');
      })
      .catch(error => {
        toast.error(error?.data?.errors);
      });
  };

  return (
    <FormProvider {...methods}>
      <LoadingOverlay visible={isLoading} style={{ borderRadius: 15 }} />
      <div className="bg-[#cfdee5] border-b-[#9ba6ab] p-5 rounded-t-md">
        <h3 className="font-bold text-[#475d68] text-xl">Login</h3>
      </div>
      <form
        className="p-8 pt-6"
        onSubmit={methods.handleSubmit(handleFormSubmit)}
      >
        <div className="grid grid-cols-1 gap-3">
          <TextInput
            props={{ size: 'lg', withAsterisk: true }}
            name="username"
            label="Gebruiker"
          />
          <PasswordInput
            props={{ size: 'lg' }}
            name="password"
            label="Wachtwoord"
          />
        </div>
        <div className="text-center mt-8">
          <Button
            disabled={methods.formState.isSubmitting || isLoading}
            type="submit"
            variant="filled"
            fullWidth
            size="lg"
          >
            {methods.formState.isSubmitting ? 'Signing in...' : 'Sign In'}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default LoginForm;
